module.exports = "../images/external-link.svg?v=cd04c0f";